// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips-info[data-v-d6165874]{line-height:18px;color:#c0c4cc;font-size:12px}.saveBtn[data-v-d6165874]{font-size:12px}", ""]);
// Exports
module.exports = exports;
